import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const STORAGE_KEY = "isugar_scroll_positions";
const LIMITE = 30;

// sessionStorage (e não memória) para a posição sobreviver ao reload e ao
// code-splitting das rotas; o mapa é podado para não crescer sem limite.
const lerMapa = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const gravarPosicao = (chave, y) => {
  try {
    const mapa = lerMapa();
    mapa[chave] = y;
    const chaves = Object.keys(mapa);
    if (chaves.length > LIMITE) delete mapa[chaves[0]];
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(mapa));
  } catch {
    // sessionStorage indisponível: segue funcionando, só não restaura
  }
};

/**
 * Rolagem entre rotas.
 *
 * Antes isto era um `window.scrollTo(0, 0)` em toda mudança de rota, inclusive
 * quando o usuário apertava Voltar: rolar 40 perfis na busca, abrir um e
 * voltar recomeçava do topo — o atrito mais repetido de um app de navegação
 * por lista.
 *
 * Agora só rola para o topo em navegação nova (PUSH/REPLACE) e restaura a
 * posição salva quando o histórico é percorrido (POP).
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();
  const chave = `${pathname}${search}`;

  useEffect(() => {
    // Salva continuamente enquanto a rota está montada; só o cleanup não
    // basta porque nem toda saída desmonta o componente a tempo.
    const aoRolar = () => gravarPosicao(chave, window.scrollY);
    window.addEventListener("scroll", aoRolar, { passive: true });
    return () => {
      window.removeEventListener("scroll", aoRolar);
      gravarPosicao(chave, window.scrollY);
    };
  }, [chave]);

  useEffect(() => {
    if (navigationType === "POP") {
      const y = lerMapa()[chave];
      if (typeof y === "number") {
        // Dois frames: o primeiro deixa o React pintar a lista, o segundo
        // encontra a página já com a altura final para rolar até a posição.
        requestAnimationFrame(() =>
          requestAnimationFrame(() => window.scrollTo(0, y)),
        );
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [chave, navigationType]);

  return null;
};

export default ScrollToTop;
